import Axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { env } from '../environment';

const AXIOS_URL = env.AXIOS_URL;

const paramsSerializer = (params: any) => {
  const searchParams = new URLSearchParams();
  for (const key of Object.keys(params)) {
    const param = params[key];
    if (Array.isArray(param)) {
      for (const p of param) {
        searchParams.append(key, p);
      }
    } else {
      searchParams.append(key, param);
    }
  }
  return searchParams.toString();
};

export const AxiosServerInstance = Axios.create({
  baseURL: `${AXIOS_URL}/`,
  timeout: 1800000,
  headers: {
    'Content-Type': 'application/json',
    // 'wd-signature': env.SIGNATURE
  },
  paramsSerializer,
});

export class HttpClient {
  constructor(private axiosInstance: AxiosInstance) {}

  request(config: AxiosRequestConfig) {
    config.params = {
      ...config.params,
    };

    return this.axiosInstance.request(config);
  }

  get(url: string, config?: any, headers?: any) {
    return this.axiosInstance.get(url, {
      params: config,
      headers,
    });
  }

  post(url: string, data: {}, config?: AxiosRequestConfig) {
    if (config) {
      config.params = {
        ...config.params,
      };
    }

    return this.axiosInstance.post(url, data, config);
  }

  put(url: string, data = {}, headers?: any, config?: AxiosRequestConfig) {
    if (config) {
      config.params = {
        ...config.params,
      };
    }

    return this.axiosInstance.put(url, data, {
      params: config,
      headers,
    });
  }

  patch(url: string, data = {}, config?: AxiosRequestConfig) {
    if (config) {
      config.params = {
        ...config.params,
      };
    }

    return this.axiosInstance.patch(url, data, config);
  }

  delete(url: string, config?: AxiosRequestConfig) {
    if (config) {
      config.params = {
        ...config.params,
      };

      config.data = {
        ...config.data,
      };
    }

    return this.axiosInstance.delete(url, config);
  }

  all(requests: any[]) {
    return Axios.all(requests);
  }
}

export const AxiosClient = new HttpClient(AxiosServerInstance);
